import { render } from "./Login.vue?vue&type=template&id=10b2a4cc&scoped=true&bindings={}"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=10b2a4cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10b2a4cc"

export default script